
import EvAlert from "./components/EvAlert";
import EvButton from "./components/EvButton";
import EvCard from "./components/EvCard";
import EvCheckBox from "./components/EvCheckBox";
import EvCounterInput from "./components/EvCounterInput";
import EvDatepicker from "./components/EvDatepicker";
import EvDateRange from "./components/EvDateRange";
import EvDialog from "./components/EvDialog";
import EvDropdown from "./components/EvDropdown";
import EvDropdownOption from "./components/EvDropdownOption";
import EvForm from "./components/EvForm";
import EvFormField from "./components/EvFormField";
import EvGroupCheckBox from "./components/EvGroupCheckBox";
import EvInput from "./components/EvInput";
import EvMoneyInput from "./components/EvMoneyInput";
import EvPagination from "./components/EvPagination";
import EvRadioGroup from "./components/EvRadioGroup";
import EvRemoteSelect from "./components/EvRemoteSelect";
import EvRemoteSelectOptions from "./components/EvRemoteSelectOptions";
import EvSelect from "./components/EvSelect";
import EvSwitch from "./components/EvSwitch";
import EvTable from "./components/EvTable";
import EvTableColumn from "./components/EvTableColumn";

import EvTagSelect from "./components/EvTagSelect";
import EvUploadInput from "./components/EvUploadInput";

import EvQueryManager from "./components/EvQueryManager";
import EvTextarea from "./components/EvTextarea";
import EvPopup from "./components/EvPopup";
import EvProgressBar from "./components/EvProgressBar";
import EvTag from "./components/EvTag";

export default {
    install(app) {
        [
            EvAlert,
            EvButton,
            EvCard,
            EvCheckBox,
            EvCounterInput,
            EvDatepicker,
            EvDateRange,
            EvDialog,
            EvDropdown,
            EvDropdownOption,
            EvForm,
            EvFormField,
            EvGroupCheckBox,
            EvInput,
            EvMoneyInput,
            EvPagination,
            EvRadioGroup,
            EvRemoteSelect,
            EvRemoteSelectOptions,
            EvSelect,
            EvSwitch,
            EvTable,
            EvTableColumn,
            EvTagSelect,
            EvUploadInput,
            EvQueryManager,
            EvTextarea,
            EvPopup,
            EvProgressBar,
            EvTag
        ].forEach((component) => app.component(component.name, component));
    }
}
